import BreadCrumb from "Components/Common/BreadCrumb";
import { normalize } from "common/lib/normalize";
import { isPaymentActive } from "common/lib/paymentOptions";
import { getPayment } from "common/services/payments.service";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { Container } from "reactstrap";
import PaymentContent from "./PaymentContent";

const ViewPayment = () => {
  const { id: paymentId } = useParams();

  const [data, setData] = useState<any>({});
  const [, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getPayment(paymentId, {});
      setData(normalize(response.data));
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, [paymentId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const status = useMemo(() => {
    return isPaymentActive(data?.startDate, data?.endDate);
  }, [data.startDate, data.endDate]);

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Payment Details"
          pageTitles={[
            {
              title: "Dashboard",
              link: "/",
            },
            { title: "Payments", link: "/payments" },
          ]}
          back
        />

        <PaymentContent payment={data} status={status} fetchData={fetchData} />
      </Container>
    </div>
  );
};

export default ViewPayment;
